import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Collapse, Divider, Grid, IconButton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SearchFilter } from "../../../../common/components/functional/FilterSearchField/FilterSearchField";
import WorkTitleAutocompleteField from "../../../../common/components/functional/fields/WorkTitleAutocompleteField";
import { BULK_SALARY_INCREASE_FILTER_NAMES, LABEL_WIDTH } from "../constants";
import { ToggleContainer } from "../styles";

type Props = {
  handleExpands: (salaryComponent: string) => void;
  expands: boolean;
  getFilter: (
    name: BULK_SALARY_INCREASE_FILTER_NAMES,
  ) => SearchFilter | undefined;
};

const BulkSalaryIncreaseAdditionalFilters = ({
  handleExpands,
  expands,
  getFilter,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Grid id="bulk-salary-increase-filters-additional" item xs={12} mb={2}>
      <ToggleContainer onClick={() => handleExpands("additionalFilters")}>
        <Typography variant="header" fontWeight={500} fontSize="20px">
          {t("settings:bulkSalaryIncrease.additionalFilters")}
        </Typography>
        <IconButton size="small">
          {expands ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
      </ToggleContainer>
      <Collapse in={expands}>
        <Grid
          container
          item
          xs={12}
          alignItems="center"
          columnSpacing={2}
          mb={2}
        >
          <Grid item style={{ width: LABEL_WIDTH, textAlign: "end" }}>
            <Typography variant="secondary">
              {
                getFilter(BULK_SALARY_INCREASE_FILTER_NAMES.WORK_TITLES)
                  ?.displayName
              }
            </Typography>
          </Grid>
          <Grid item xs>
            <WorkTitleAutocompleteField
              name={BULK_SALARY_INCREASE_FILTER_NAMES.WORK_TITLES}
              inputSx={{ maxWidth: "624px" }}
            />
          </Grid>
        </Grid>
      </Collapse>
      <Divider />
    </Grid>
  );
};

export default BulkSalaryIncreaseAdditionalFilters;
